// test2847
(2847 && 0);
